<template>
  <div class="pa-1">
    <!-- Card 1: Información de Productor y Lote -->
    <v-card class="pa-3 mb-3 rounded-lg border-subtle elevation-1 bg-white">
      <div class="d-flex align-center justify-space-between mb-2">
        <div class="d-flex align-center">
          <v-icon color="primary" small class="mr-2">mdi-map-marker-path</v-icon>
          <span class="subtitle-2 font-weight-bold primary--text">1. Ubicación y Lote (Búsqueda por Cod. Senasa)</span>
        </div>
        <v-chip x-small color="blue-grey lighten-5" text-color="primary" class="font-weight-bold" v-if="objLot && objLot.FltID">
          Lote ID: #{{ objLot.FltID }}
        </v-chip>
      </div>
      <v-divider class="mb-3"></v-divider>

      <v-row dense class="s-col-form mb-2 align-center">
        <v-col cols="12" md="4">
          <s-search-lot-by-cod-senasa @searchSenasa="searchSenasa($event)" />
        </v-col>
        <v-col cols="12" md="8">
          <div class="d-flex flex-wrap align-center gap-2 pa-2 rounded bg-light border-subtle" v-if="objLot && objLot.FltID">
            <v-chip small color="white" class="elevation-1 font-weight-medium">
              <v-icon left x-small color="primary">mdi-account-tie</v-icon>
              <strong>Productor:</strong>&nbsp;{{ objLot.PrdText }}
            </v-chip>
            <v-chip small color="white" class="elevation-1 font-weight-medium">
              <v-icon left x-small color="green darken-2">mdi-tree</v-icon>
              <strong>Fundo:</strong>&nbsp;{{ objLot.FagName }}
            </v-chip>
            <v-chip small color="white" class="elevation-1 font-weight-medium">
              <v-icon left x-small color="orange darken-3">mdi-grid</v-icon>
              <strong>Lote:</strong>&nbsp;{{ objLot.FltName }}
            </v-chip>
          </div>
          <div class="caption text-center grey--text text--darken-1 font-italic py-2" v-else>
            Ingrese o escanee el Código Senasa para autocompletar el Lote, Fundo y Productor.
          </div>
        </v-col>
      </v-row>
    </v-card>

    <!-- Card 2: Estimación de Cosecha -->
    <v-card class="pa-3 mb-3 rounded-lg border-subtle elevation-1 bg-white">
      <div class="d-flex align-center mb-2">
        <v-icon color="primary" small class="mr-2">mdi-chart-line-variant</v-icon>
        <span class="subtitle-2 font-weight-bold primary--text">2. Proyección y Estimación de Cosecha</span>
      </div>
      <v-divider class="mb-3"></v-divider>

      <v-row dense class="s-col-form mb-2">
        <v-col cols="12" md="3">
          <s-date label="Fecha Estimada" v-model="item.HpsDate"></s-date>
        </v-col>
        <v-col cols="12" md="3">
          <s-text label="Cultivo" readonly v-model="objLot.TypeCultiveText"></s-text>
        </v-col>
        <v-col cols="12" md="3">
          <s-select-definition label="Tipo Cultivo" :def="1172" v-model="objLot.TypeCrop" />
        </v-col>
        <v-col cols="12" md="3">
          <s-text label="Variedad" readonly v-model="objLot.VrtDescription"></s-text>
        </v-col>
      </v-row>

      <v-row dense class="s-col-form align-center">
        <v-col cols="12" md="6">
          <v-card flat class="pa-2 rounded-lg border-primary-light bg-blue-light d-flex align-center justify-space-between">
            <div class="d-flex align-center">
              <v-avatar color="primary" size="32" class="mr-2">
                <v-icon small color="white">mdi-basket-outline</v-icon>
              </v-avatar>
              <div>
                <div class="caption font-weight-bold grey--text text--darken-3">Cantidad de Jabas Estimadas</div>
                <div class="caption grey--text">Proyección preliminar en campo</div>
              </div>
            </div>
            <div style="width: 140px;">
              <s-text number v-model="item.HpsEstimatedJabas" class="bold-input" placeholder="0"></s-text>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" md="6">
          <s-select-foreman autocomplete full clearable label="Capataz Sugerido (Opcional)" v-model="item.FrmID"></s-select-foreman>
        </v-col>
      </v-row>
    </v-card>

    <!-- Card 3: Observaciones -->
    <v-card class="pa-3 rounded-lg border-subtle elevation-1 bg-white">
      <div class="d-flex align-center mb-2">
        <v-icon color="primary" small class="mr-2">mdi-note-text-outline</v-icon>
        <span class="subtitle-2 font-weight-bold primary--text">3. Observaciones Adicionales</span>
      </div>
      <v-divider class="mb-2"></v-divider>

      <v-row dense class="s-col-form">
        <v-col cols="12">
          <s-text label="Observaciones / Comentarios de Campo" v-model="item.HpsObservation" placeholder="Ingrese notas relevantes sobre la pre-programación..." />
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import SSearchLotByCodSenasa from "@/components/HarvestSchedule/sSearchLotByCodSenasa.vue";
import SSelectForeman from "@/components/HarvestSchedule/SSelectForeman";
import _sHarvestPreSchedule from "@/services/Technicalassistance/HarvestPreScheduleService";

export default {
  name: "HarvestPreScheduleEdit",
  components: {
    SSearchLotByCodSenasa,
    SSelectForeman,
  },
  props: {
    objEdit: { type: Object, default: null },
  },
  data() {
    return {
      item: {
        HpsID: 0,
        HpsDate: new Date().toISOString().substring(0, 10),
        HpsEstimatedJabas: 0,
        HpsObservation: "",
        FrmID: null,
        HpsStatus: 1,
      },
      objLot: {},
    };
  },
  methods: {
    searchSenasa(item) {
      if (item) {
        this.objLot = item;
      }
    },

    save() {
      if (!this.item.HpsDate) {
        this.$fun.alert("Seleccione Fecha Estimada", "warning");
        return;
      }
      if (!this.objLot.FltID) {
        this.$fun.alert("Seleccione Lote (Cod Senasa)", "warning");
        return;
      }
      if (!this.item.HpsEstimatedJabas || this.item.HpsEstimatedJabas <= 0) {
        this.$fun.alert("Ingrese una cantidad válida de Jabas Estimadas", "warning");
        return;
      }

      this.item.FltID = this.objLot.FltID;
      this.item.FagID = this.objLot.FagID;
      this.item.PrdID = this.objLot.PrdID;
      this.item.TypeCultive = this.objLot.TypeCultive;
      this.item.TypeCrop = this.objLot.TypeCrop;
      this.item.VrtID = this.objLot.VrtID;

      this.$fun.alert("¿Seguro de Guardar la Pre-Programación?", "question").then((r) => {
        if (r.value) {
          _sHarvestPreSchedule
            .save(this.item, this.$fun.getUserID())
            .then((resp) => {
              if (resp.status === 200) {
                this.$fun.alert("Pre-Programación guardada correctamente", "success");
                this.$emit("close");
              }
            })
            .catch(() => {
              this.$fun.alert("Error al guardar la pre-programación", "error");
            });
        }
      });
    },
  },
  created() {
    if (this.objEdit && this.objEdit.HpsID > 0) {
      this.item = Object.assign({}, this.objEdit);
      this.objLot = {
        FltID: this.item.FltID,
        FltName: this.item.FltName,
        FagName: this.item.FagName,
        FagID: this.item.FagID,
        PrdText: this.item.PrdText,
        PrdID: this.item.PrdID,
        VrtDescription: this.item.VrtDescription,
        VrtID: this.item.VrtID,
        TypeCropText: this.item.TypeCropText,
        TypeCrop: this.item.TypeCrop,
        TypeCultiveText: this.item.TypeCultiveText,
        TypeCultive: this.item.TypeCultive,
      };
    }
  },
};
</script>

<style scoped>
.border-subtle {
  border: 1px solid #E0E0E0 !important;
}
.border-primary-light {
  border: 1px solid #BBDEFB !important;
}
.bg-light {
  background-color: #F8F9FA !important;
}
.bg-blue-light {
  background-color: #E3F2FD !important;
}
.gap-2 {
  gap: 8px;
}
</style>
